import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { login, logout, checkAuthStatus, clearError } from '../store/authSlice';
import { useEffect } from 'react';

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useSelector((state: RootState) => state.auth);

  // 在组件挂载时检查认证状态
  useEffect(() => {
    dispatch(checkAuthStatus());
  }, [dispatch]);

  const handleLogin = async (username: string, password: string) => {
    return dispatch(login({ username, password }));
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  const clearAuthError = () => {
    dispatch(clearError());
  };

  return {
    ...auth,
    login: handleLogin,
    logout: handleLogout,
    clearError: clearAuthError,
  };
};
